// Third-party
import React from 'react';
// Components
import { ControlItem, SegmentedControl } from '@/views/components/navigation';

// Utils
import { PERFORMANCE_CHART } from '@/utils/constants';
import { FormattedMessage } from '@/utils/i18n';

type Props = {
  charts: PERFORMANCE_CHART[];
  value: PERFORMANCE_CHART;
  onChange: (value: PERFORMANCE_CHART) => void;
  dark?: boolean;
};

class ChartPicker extends React.Component<Props> {
  getControlItems = () => {
    const { charts, dark } = this.props;
    return [
      {
        value: PERFORMANCE_CHART.GROWTH,
        messageId: 'Comparison.Performance.Charts.Growth',
        icon: `chart-line${!dark ? '-2' : ''}`,
      },
      {
        value: PERFORMANCE_CHART.RISK_REWARD,
        messageId: 'Comparison.Performance.Charts.RiskReward',
        icon: `chart-scatter${!dark ? '-2' : ''}`,
      },
      {
        value: PERFORMANCE_CHART.DRAWDOWN,
        messageId: 'Comparison.Performance.Charts.Drawdown',
        icon: `chart-underwater${!dark ? '-2' : ''}`,
      },
    ].filter(item => charts.includes(item.value));
  };

  render() {
    const { value, dark } = this.props;

    const onChange = (val: any) => {
      this.props.onChange(val);
    };

    return (
      <div className="chart-picker">
        <SegmentedControl dark={dark} darkerBackground orientation="horizontal" selected={value} onChange={onChange}>
          {this.getControlItems().map(item => (
            <ControlItem key={item.value} value={item.value} aria-selected={value === item.value} role="tab">
              <i className={`icon-${item.icon}`} />
              <FormattedMessage id={item.messageId} />
            </ControlItem>
          ))}
        </SegmentedControl>
      </div>
    );
  }
}

export default ChartPicker;
